import React, { useState } from 'react';
import { Button } from 'carbon-components-react';
import { CaretLeft20, CaretRight20 } from '@carbon/icons-react';

const CustomPagination: React.FC<Props> = ({
  totalItems,
  page,
  pageSize = 10,
  onChange
}) => {
  const totalPage = Math.ceil(totalItems / pageSize);
  const [currentPage, setCurrentPage] = useState<number>(page);

  const handlePaginationButtonClick = (direction: string) => {
    let page = currentPage;
    if (direction === 'next') {
      page = currentPage + 1;
      setCurrentPage(page);
    }
    if (direction === 'previous') {
      page = currentPage - 1;
      setCurrentPage(page);
    }
    const data = {
      page,
      pageSize
    };
    onChange(data);
  };

  return (
    <div className="custom-pagination">
      <div className="custom-pagination-left">
        <div className="custom-pagination-left-text">
          {`${totalItems} result${totalItems > 1 ? 's' : ''}`}
        </div>
      </div>
      <div className="custom-pagination-right">
        <div className="custom-pagination-text">
          {`${page} of ${totalPage}`}
        </div>
        <div className="custom-pagination-control-buttons">
          <div
            className={`custom-pagination-button ${
              page === 1 ? 'disable-button' : ''
            }`}
          >
            <Button
              renderIcon={CaretLeft20}
              kind="ghost"
              disabled={page === 1}
              onClick={() => handlePaginationButtonClick('previous')}
            />
          </div>
          <div
            className={`custom-pagination-button ${
              page === totalPage ? 'disable-button' : ''
            }`}
          >
            <Button
              renderIcon={CaretRight20}
              kind="ghost"
              disabled={page === totalPage}
              onClick={() => handlePaginationButtonClick('next')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

type Props = {
  totalItems: number;
  page: number;
  pageSize: number;
  onChange: Function;
};

export default React.memo(CustomPagination);
